import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { AccountDataDispatcher } from './account-data.dispatcher';
import { AccountDataEffects } from './account-data.effects';
import { FEATURE_NAME, reducer } from './account-data.reducer';
import { AccountDataResolve } from './account-data.resolve';
import { AccountDataService } from './account-data.service';
import { AccountDataStore } from './account-data.store';

export const accountDataEffects = [AccountDataEffects];

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(FEATURE_NAME, reducer)],
})
export class AccountDataModule {
  static forRoot(): ModuleWithProviders<AccountDataModule> {
    return {
      ngModule: AccountDataModule,
      providers: [
        AccountDataStore,
        AccountDataService,
        AccountDataResolve,
        AccountDataDispatcher,
      ],
    };
  }
}
